/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Tab_PlansInputs */

const en_client_tab_plans = /** @type {(inputs: Client_Tab_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training`)
};

const pl_client_tab_plans = /** @type {(inputs: Client_Tab_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening`)
};

/**
* | output |
* | --- |
* | "Training" |
*
* @param {Client_Tab_PlansInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const client_tab_plans = /** @type {((inputs?: Client_Tab_PlansInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Tab_PlansInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_client_tab_plans(inputs)
	return en_client_tab_plans(inputs)
});